import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'retailers-retailer_on_choose_option_from_quicker_add-click';
/**
 * this event fires when retailer click choose multi option using quicker quick add
 */ export function trackRetailersRetailerOnChooseOptionFromQuickerAddClick(retailerToken) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            retailerToken: retailerToken
        }
    });
}
